"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      width: '100%',
      '&:focus-visible': {
        outline: 'none'
      },
      '&:focus-visible $inputWrapper': {
        borderColor: theme.palette.BLUE400,
        outline: 'none'
      },
      '&:focus-visible $label': {
        color: theme.palette.BLUE400
      }
    },
    label: {
      display: 'block',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.NEUTRAL300,
      marginBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5)
    },
    required: {
      color: theme.palette.RED400
    },
    labelInline: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL300,
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(0.5)
    },
    labelInvalid: {
      color: theme.palette.RED400
    },
    labelDisabled: {
      color: theme.palette.NEUTRAL300
    },
    labelFocused: {
      color: theme.palette.BLUE400
    },
    input: {
      width: 200
    },
    listbox: {
      width: '100%',
      marginTop: theme.spacing(1),
      padding: theme.spacing(1, 0),
      zIndex: 2,
      position: 'absolute',
      listStyle: 'none',
      backgroundColor: theme.palette.background.paper,
      overflow: 'auto',
      maxHeight: 300,
      boxShadow: theme.shadows[2],
      borderRadius: 4,
      '& li': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(22),
        padding: theme.spacing(0.5, 2),
        color: theme.palette.NEUTRAL800,
        display: 'flex',
        alignItems: 'center'
      },
      '& li[data-focus="true"]': {
        backgroundColor: theme.palette.BLUE050,
        cursor: 'pointer'
      },
      '& li:active': {
        backgroundColor: theme.palette.BLUE075
      }
    },
    listboxWithDescription: {
      transform: 'translateY(-24px)'
    },
    inputWrapper: {
      border: "1px solid ".concat(theme.palette.NEUTRAL050),
      padding: theme.spacing(0.875, 1.5),
      backgroundColor: theme.palette.NEUTRAL000,
      borderRadius: 4,
      display: 'flex',
      boxSizing: 'border-box',
      '&:hover': {
        border: "1px solid ".concat(theme.palette.NEUTRAL100)
      },
      '&.focused': {
        borderColor: '#40a9ff',
        boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)',
        outline: "1px solid ".concat(theme.palette.BLUE500)
      },
      '& input': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: 1.875,
        color: theme.palette.NEUTRAL800,
        fontFamily: '"Open Sans", sans-serif',
        fontWeight: 700,
        boxSizing: 'border-box',
        flexGrow: 1,
        border: 0,
        margin: 0,
        outline: 0,
        width: '25%'
      },
      '& input::placeholder': {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 400,
        color: theme.palette.NEUTRAL300
      },
      '&:hover $clearAll': {
        visibility: 'visible'
      }
    },
    inputWrapperInvalid: {
      borderWidth: 2,
      borderColor: theme.palette.RED400,
      '&:hover': {
        borderWidth: 2,
        borderColor: theme.palette.RED500
      }
    },
    inputWrapperDisabled: {
      backgroundColor: theme.palette.NEUTRAL030,
      '&:hover': {
        borderColor: theme.palette.NEUTRAL050
      },
      '& input': {
        backgroundColor: theme.palette.NEUTRAL030,
        color: theme.palette.NEUTRAL300
      },
      '& $caretIcon': {
        color: theme.palette.NEUTRAL300
      }
    },
    inputWrapperFocused: {
      borderColor: theme.palette.BLUE400,
      outline: "1px solid ".concat(theme.palette.BLUE500),
      '&:hover': {
        borderColor: theme.palette.BLUE500
      }
    },
    inputValueContainer: {
      flex: 'auto',
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative'
    },
    caretIcon: {
      color: theme.palette.NEUTRAL700,
      display: 'flex',
      alignItems: 'center'
    },
    caretUp: {
      transform: 'translateY(-1px)'
    },
    clearAll: {
      color: theme.palette.NEUTRAL700,
      display: 'flex',
      alignItems: 'center',
      visibility: 'hidden',
      marginRight: theme.spacing(0.5)
    },
    description: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL300,
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(0.5),
      display: 'flex',
      alignItems: 'center'
    },
    descriptionInvalid: {
      color: theme.palette.RED400,
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
        marginRight: theme.spacing(0.5)
      }
    },
    tag: {
      display: 'flex',
      alignItems: 'center',
      margin: theme.spacing(0.25, 0.25),
      backgroundColor: theme.palette.BLUE050,
      border: "1px solid ".concat(theme.palette.BLUE050),
      borderRadius: 4,
      boxSizing: 'content-box',
      padding: theme.spacing(0.375, 1),
      outline: 0,
      overflow: 'hidden',
      zIndex: 1,
      '&:hover': {
        backgroundColor: theme.palette.BLUE075
      },
      '&:focus': {
        borderColor: '#40a9ff',
        backgroundColor: '#e6f7ff'
      },
      '&:focus-visible': {
        borderColor: theme.palette.BLUE400,
        outline: 'none',
        backgroundColor: theme.palette.BLUE050
      },
      '& span': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(14),
        color: theme.palette.NEUTRAL800
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(12),
        cursor: 'pointer',
        marginLeft: theme.spacing(0.5),
        color: theme.palette.NEUTRAL700
      }
    },
    optionSelected: {
      '$listbox &': {
        color: theme.palette.NEUTRAL800,
        fontWeight: 600
      }
    },
    iconSelected: {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.BLUE300,
      marginLeft: theme.spacing(1),
      display: 'flex'
    }
  };
});
var _default = useStyles;
exports.default = _default;